import React from 'react'

import { CONTENTSPAGE_DATA } from '@/page_data/contentsPage'

import BannerSection from '@/components/LandingPage/BannerSection'
import ContentDetailsSection from './ContentDetailsSection'

const ContentsPage = () => {
  return (
    <>
      <BannerSection data={CONTENTSPAGE_DATA.banner} />
      <ContentDetailsSection data={CONTENTSPAGE_DATA.details} />
    </>
  )
}

export default ContentsPage
